'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msActionItem', {
    bindings: {
      actionItemCopy: '<',
      saveAction: '&',
      undoAction: '&',
      existingList: '<',
      previouslyAdded: '<'
    },
    templateUrl: 'vnext/templates/ms-action-item.html',
    controller: ActionItemCtrl
  });

  ActionItemCtrl.$inject = ['$log'];

  function ActionItemCtrl($log) {
    var vm = this;
    vm.$onInit = activate;
    vm.callSaveAction = callSaveAction;
    vm.undoSaveAction = undoSaveAction;
    vm.dismiss = dismiss;

    ///////////////////////////////

    function activate() {
      $log.debug('ActionItemCtrl activate.');
      vm.hasBeenAdded = angular.copy(vm.previouslyAdded);
    }

    function callSaveAction() {
      vm.pending = true;
      vm.saveAction().then(function () {
        vm.hasBeenAdded = true;
        vm.pending = false;
      });
    }

    function undoSaveAction() {
      vm.undoAction().then(function () {
        vm.hasBeenAdded = false;
        vm.hasNotBeenAdded = false;
      });
    }

    function dismiss() {
      $log.debug('dismiss');
      vm.hasNotBeenAdded = true;
    }
  }
})();